import { InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type InputProps = {
    invalid?: boolean
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

export const Toggle = ({invalid, disabled, ...rest}: InputProps) => {
    return (
        <label className={'cursor-pointer'}>
            <input
                {...rest}
                type={'checkbox'}
                disabled={disabled}
                defaultChecked={undefined}
                className={'sr-only peer'}/>

            <div className={twMerge(
                'relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-container rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[\'\'] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary',
                disabled && 'cursor-not-allowed bg-surface-1 hover:bg-surface-1',
                invalid && 'border-error focus:border-error focus-visible:ring-error'
            )} />
        </label>
    );
};
